import ApiClient from '@package/services/src/ApiClient';
import Result from '@package/services/src/Result';
import config from 'config-base';
import { SearchService } from './services';
import { SearchResult } from './types';

export default class SearchApiService implements SearchService {
  public constructor(private readonly apiClient: ApiClient) {}

  public async getSearchResults(
    searchQueryKey: string,
    start = '0',
    rows = '9',
    brandCode = config.brandCode,
  ): Promise<Result<Array<SearchResult> | undefined>> {
    try {
      const searchUrlParams = new URLSearchParams([
        ['query', searchQueryKey],
        ['start', start],
        ['rows', rows],
        ['brandCode', brandCode],
        ['filter', 'type:CATEGORY OR type:TOPTRENDS '],
        ['log', 'true'],
      ]);
      const res = await this.apiClient.get(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `/search/autocomplete?${searchUrlParams}`,
      );
      const json = await res.json();

      return new Result(json);
    } catch (error) {
      console.error("can't get search results", error);
      return new Result(undefined);
    }
  }
}
